import React, {useEffect, useState} from "react";
import Breadcrumbs from "../../../components/breadcrumbs";
import {ToastContainer, toast} from 'react-toastify';
import Dropzone from "../../../components/dropzone";
import Button from "../../../components/button";
import DataTable from "../../../components/data-table";
import {Link} from "react-router-dom";
import {
    clear_bonus, export_file,
    get_all_bonus,
    IMPORT_BONUS,
    importBonus
} from "../../../redux/bonus";
import {get_status_task} from "../../../redux/employees";
import {useDispatch, useSelector} from "react-redux";
import LoadingSpinner from "../../../components/loading-spinner";
import SelectInput from "../../../components/select";
import Modal from "../../../components/modal";

const ImportBonus = () => {
    let dispatch = useDispatch();

    const _import_bonus = useSelector((store) => store.bonus_module._import_bonus);
    // const _general_settings = useSelector((store) => store.base_module._general_settings_all)
    const {token} = useSelector((state) => state.users_module.login.data) || null;
    const [progress, setProgress] = useState(0);
    let timer = null;

    const [result, setResult] = useState([])

    const [load, setLoad] = useState(false);
    const [file, setFile] = useState(null);
    // const [settings, setSettings] = useState([])
    // const [url_template, setUrlTemplate] = useState(null)
    const [modal, setModal] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [year, setYear] = useState(0);
    const [month, setMonth] = useState(0);

    // useEffect(() => {
    //     if (_general_settings.data) {
    //         setSettings(_general_settings.data)
    //     }
    // }, [_general_settings.data])

    // useEffect(() => {
    //     let datos = settings.filter(x => x.key === URL_FILE_UPLOAD_BONUS)
    //     if (datos.length !== 0) {
    //         setUrlTemplate(datos[0].value)
    //     }
    // }, [settings])

    useEffect(() => {
        if (_import_bonus.status === 200) {
            setLoad(true);

            if (_import_bonus.data) {
                if (timer == null) {
                    status_task(_import_bonus.data);
                }

            }
            dispatch(get_all_bonus(token));
            dispatch(clear_bonus(IMPORT_BONUS));
        } else if (_import_bonus.status !== 0) {
            setLoad(false)

            toast.error(_import_bonus.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

            dispatch(clear_bonus(IMPORT_BONUS))

        }
        // eslint-disable-next-line
    }, [_import_bonus, dispatch, token])


    const clearTimer = (timer) => {
        clearInterval(timer);
        timer = null;
        dispatch(clear_bonus(IMPORT_BONUS))
    };

    const status_task = (data) => {
        timer = setInterval(() => {
            get_status_task(data.task_id, token)
                .then((res) => {
                    if (res.status === 202) {
                        setProgress(res.data.data.meta.result.current);
                    } else if (res.status === 200) {
                        setProgress(100);
                        setResult(res.data.data.meta.result.datos)
                        clearTimer(timer);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    setLoad(false);
                    setProgress(0);
                    clearTimer(
                        timer
                    );
                });
        }, 5000);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let form = new FormData();
        form.append("archivo_excel", file);
        setLoad(true);
        dispatch(importBonus(token, form));
    }

    const handleFile = (e) => {
        setFile(e.target.files[0]);
    }

    async function handleDownloadTemplateFile(e) {
        e.preventDefault();
        setIsLoading(true);
        try {
            const response = await export_file(token, {mes: month, anio: year});
            if (response && response.data) {
                const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = 'Plantilla de bonificaciones.xlsx';  // Nombre del archivo descargado
                link.click();
                setModal(false);
            }
            setIsLoading(false);
        } catch (e) {
           setIsLoading(false);
        }
    }

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 3 }, (_, i) => currentYear - 1 + i);
    const months = [
        {id: 1, value: "Enero"},
        {id: 2, value: "Febrero"},
        {id: 3, value: "Marzo"},
        {id: 4, value: "Abril"},
        {id: 5, value: "Mayo"},
        {id: 6, value: "Junio"},
        {id: 7, value: "Julio"},
        {id: 8, value: "Agosto"},
        {id: 9, value: "Septiembre"},
        {id: 10, value: "Octubre"},
        {id: 11, value: "Noviembre"},
        {id: 12, value: "Diciembre"},
    ];

    return (
        <div className="app-content content">
            <div className="content-overlay"/>
            <ToastContainer/>
            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Lista"
                            items={[{label: "Bonificaciones", link: "/bonificaciones"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                <section>
                                    <div className="row flexbox-container">
                                        <div className="col-12 text-center p-3">
                                            <h1 className="error-title mb-2">Importar bonificación</h1>
                                            <p className="mb-1">
                                                Se admite archivo excel
                                            </p>

                                            <Button type="button" text="Descargar plantilla" theme="btn btn-success" onClick={() => {
                                                document.getElementById("yearA").selectedIndex = 0;
                                                document.getElementById("monthA").selectedIndex = 0;
                                                setModal(true);
                                            }}/>

                                            <div id="clockFlat" className="card-text text-center coming-soon pt-2 d-flex justify-content-center mb-2"/>
                                            <form onSubmit={handleSubmit}>
                                                <fieldset className="form-group position-relative w-75 mx-auto">
                                                    <Dropzone id="foto" name="foto" handleChange={
                                                        (e) => {
                                                            handleFile(e)
                                                        }
                                                    }
                                                              state={file}
                                                              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                    />
                                                    <div className="row">
                                                        <div className="col-12">

                                                            {
                                                                load ? <div className="progress">
                                                                        <div className="progress-bar bg-success"
                                                                             role="progressbar"
                                                                             style={{width: progress + '%'}}
                                                                             aria-valuenow="25" aria-valuemin="0"
                                                                             aria-valuemax="100">{progress}%
                                                                        </div>
                                                                    </div>
                                                                    : <Button classes="cs-btn-notify round mt-3"
                                                                              theme="primary" type="submit"
                                                                              text="Enviar"/>
                                                            }

                                                        </div>
                                                        {
                                                            result.length !== 0 &&
                                                                <div className="table-responsive">
                                                                    <DataTable
                                                                        dataTable={result}
                                                                        columns={[
                                                                            {
                                                                                name: "fila",
                                                                                label: "Fila",
                                                                                type: "text",
                                                                            },
                                                                            {
                                                                                name: "creado",
                                                                                label: "Creado",
                                                                                type: "boolean",
                                                                            },
                                                                            {
                                                                                name: "mensaje",
                                                                                label: "Mensaje",
                                                                                type: "text",
                                                                            },

                                                                        ]}
                                                                        actions={null}
                                                                    />
                                                                </div>
                                                        }
                                                        <div className="col-12">
                                                            <Link to="/bonificaciones"
                                                                  className=" round btn btn-danger mt-1">
                                                                Cancelar
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </fieldset>
                                            </form>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                {isLoading && <LoadingSpinner/>}
                <div className="modal-content">
                    <div className="modal-header">
                        <h5>Plantilla de bonificación</h5>
                    </div>
                    <div className="modal-body p-2">
                        <form onSubmit={handleDownloadTemplateFile}>
                            <div className="form-group">
                                <label>Mes</label>
                                <SelectInput
                                    id="monthA"
                                    label="mes"
                                    name="mes"
                                    onChange={(e) => setMonth(e.target.value)}
                                    options={months ? months.map((item) => ({
                                        name: item.value,
                                        id: item.id,
                                    })) : []}
                                />
                            </div>
                            <div className="form-group">
                                <label>Año</label>
                                <SelectInput
                                    id="yearA"
                                    label="año"
                                    name="anio"
                                    onChange={(e) => setYear(e.target.value)}
                                    options={years ? years.map((item) => ({
                                        name: item,
                                        id: item,
                                    })) : []}
                                />
                            </div>
                            <div className="text-center">
                                <Button type="submit" text="Exportar" theme="btn btn-success" classes="m-1"
                                        disabled={isLoading}/>
                                <button type="button" className="btn btn-outline-dark" onClick={() => {
                                    setModal(false);
                                }}> Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>
        </div>
    )

}

export default ImportBonus;